<div class="auth-shell">
  <app-topbar-layout></app-topbar-layout>
  <div class="auth-shell__main">
    <app-sidebar></app-sidebar>
    <div class="auth-shell__content">
      <div class="auth-shell__content-inner">
        <router-outlet />
      </div>
      <div class="auth-shell__end-space" aria-hidden="true"></div>
    </div>
  </div>
</div>
<app-toast-container />
<app-confirm-modal />
